import { render, staticRenderFns } from "./lang-switch.vue?vue&type=template&id=5a890865&scoped=true&"
import script from "./lang-switch.vue?vue&type=script&lang=js&"
export * from "./lang-switch.vue?vue&type=script&lang=js&"
import style0 from "./lang-switch.vue?vue&type=style&index=0&id=5a890865&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a890865",
  null
  
)

component.options.__file = "lang-switch.vue"
export default component.exports